<template>
  <div id="ag-grid-demo">
    <vx-card class="p-4 mb-6">
      <div class="flex flex-wrap items-center justify-between mb-10">
        <div class="flex items-center">
          <h4 style="margin-left: 10px">Group Access</h4>
        </div>
        <div class="flex items-center">
          <vs-button @click="refreshData" class="btn mb-4 md:mb-0 mr-1" icon="refresh">Refresh</vs-button>
          <vs-button @click="addForm" class="btn mb-4 md:mb-0 mr-1" icon="add">Add</vs-button>
          <vs-button
            @click="viewEditForm"
            class="mb-4 md:mb-0 mr-1"
            icon="remove_red_eye"
            :disabled="selectedId ? false : true"
          >View</vs-button>
          <vs-button
            class="mb-4 md:mb-0 mr-1"
            @click="removeItem"
            icon="delete"
            :disabled="selectedId ? false : true"
          >Delete</vs-button>
          <vs-button class="mb-4 md:mb-0 mr-1" icon="filter_list" @click="filterForm">Filter</vs-button>
        </div>
      </div>
      <ag-grid-vue
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="groupAccesses"
        colResizeDefault="shift"
        :animateRows="false"
        :floatingFilter="false"
        rowSelection="single"
        @selection-changed="onSelectionChanged"
        @rowDoubleClicked="viewEditForm"
      ></ag-grid-vue>
      <p class="text-right">
        <b>Showing {{ dataFrom }} to {{ dataTo }} of {{ dataTotal }} total entries</b>
      </p>
      <vs-pagination :total="totalPage" v-model="currentPage"></vs-pagination>
      <vs-prompt @accept="filterSubmit" :active.sync="showFilter" title="Filter Group Access">
        <div class="vx-col">
          User Group
        </div>
        <div class="vx-col">
          <vx-input-group>
            <vs-input v-model="filter.user_group" />
            <template slot="append">
                <div class="append-text btn-addon">
                    <vs-button
                        size="small"
                        color="primary"
                        icon-pack="feather"
                        icon="icon-search"
                        @click="searchUserGroup"
                    ></vs-button>
                </div>
            </template>
          </vx-input-group>
        </div>
        <div class="vx-col mt-2">
          Menu
        </div>
        <div class="vx-col">
          <vx-input-group>
            <vs-input v-model="filter.menu" />
            <template slot="append">
                <div class="append-text btn-addon">
                    <vs-button
                        size="small"
                        color="primary"
                        icon-pack="feather"
                        icon="icon-search"
                        @click="searchMenu"
                    ></vs-button>
                </div>
            </template>
          </vx-input-group>
        </div>
      </vs-prompt>
      <vs-prompt @accept="addSubmit" :active.sync="showAdd" title="Add Group Access">
        <div class="vx-col">
          User Group
        </div>
        <div class="vx-col">
          <vx-input-group>
            <vs-input v-model="form.user_group" />
            <template slot="append">
                <div class="append-text btn-addon">
                    <vs-button
                        size="small"
                        color="primary"
                        icon-pack="feather"
                        icon="icon-search"
                        @click="searchUserGroup"
                    ></vs-button>
                </div>
            </template>
          </vx-input-group>
        </div>
        <div class="vx-col mt-2">
          Menu
        </div>
        <div class="vx-col">
          <vx-input-group>
            <vs-input v-model="form.menu" />
            <template slot="append">
                <div class="append-text btn-addon">
                    <vs-button
                        size="small"
                        color="primary"
                        icon-pack="feather"
                        icon="icon-search"
                        @click="searchMenu"
                    ></vs-button>
                </div>
            </template>
          </vx-input-group>
        </div>
        <div class="vx-col mt-4 mb-2">
          <div class="vx-row mb-3 mt-1">
            <div class="vx-col w-1/2">
              <vs-checkbox v-model="form.create">Create</vs-checkbox>
            </div>
            <div class="vx-col w-1/2">
              <vs-checkbox v-model="form.read">Read</vs-checkbox>
            </div>
          </div>
        </div>
        <div class="vx-col mt-4 mb-2">
          <div class="vx-row mb-3 mt-1">
            <div class="vx-col w-1/2">
              <vs-checkbox v-model="form.update">Update</vs-checkbox>
            </div>
            <div class="vx-col w-1/2">
              <vs-checkbox v-model="form.delete">Delete</vs-checkbox>
            </div>
          </div>
        </div>
        <div class="vx-col mt-4 mb-2">
          <div class="vx-row mb-3 mt-1">
            <div class="vx-col w-1/2">
              <vs-checkbox v-model="form.print">Print</vs-checkbox>
            </div>
            <div class="vx-col w-1/2">
              <vs-checkbox v-model="form.export">Export</vs-checkbox>
            </div>
          </div>
        </div>
        <div class="vx-col mt-4 mb-2">
          <div class="vx-row mb-3 mt-1">
            <div class="vx-col w-1/2">
              <vs-checkbox v-model="form.confirm">Confirm</vs-checkbox>
            </div>
            <div class="vx-col w-1/2">
              <vs-checkbox v-model="form.enable">Enable</vs-checkbox>
            </div>
          </div>
        </div>
      </vs-prompt>
      <vs-prompt @accept="viewEditSubmit" :active.sync="showViewEdit" title="View Group Access">
        <div class="vx-col">
          User Group
        </div>
        <div class="vx-col">
          <vx-input-group>
            <vs-input v-model="form.user_group" />
            <template slot="append">
                <div class="append-text btn-addon">
                    <vs-button
                        size="small"
                        color="primary"
                        icon-pack="feather"
                        icon="icon-search"
                        @click="searchUserGroup"
                    ></vs-button>
                </div>
            </template>
          </vx-input-group>
        </div>
        <div class="vx-col mt-2">
          Menu
        </div>
        <div class="vx-col">
          <vx-input-group>
            <vs-input v-model="form.menu" />
            <template slot="append">
                <div class="append-text btn-addon">
                    <vs-button
                        size="small"
                        color="primary"
                        icon-pack="feather"
                        icon="icon-search"
                        @click="searchMenu"
                    ></vs-button>
                </div>
            </template>
          </vx-input-group>
        </div>
        <div class="vx-col mt-4 mb-2">
          <div class="vx-row mb-3 mt-1">
            <div class="vx-col w-1/2">
              <vs-checkbox v-model="form.create">Create</vs-checkbox>
            </div>
            <div class="vx-col w-1/2">
              <vs-checkbox v-model="form.read">Read</vs-checkbox>
            </div>
          </div>
        </div>
        <div class="vx-col mt-4 mb-2">
          <div class="vx-row mb-3 mt-1">
            <div class="vx-col w-1/2">
              <vs-checkbox v-model="form.update">Update</vs-checkbox>
            </div>
            <div class="vx-col w-1/2">
              <vs-checkbox v-model="form.delete">Delete</vs-checkbox>
            </div>
          </div>
        </div>
        <div class="vx-col mt-4 mb-2">
          <div class="vx-row mb-3 mt-1">
            <div class="vx-col w-1/2">
              <vs-checkbox v-model="form.print">Print</vs-checkbox>
            </div>
            <div class="vx-col w-1/2">
              <vs-checkbox v-model="form.export">Export</vs-checkbox>
            </div>
          </div>
        </div>
        <div class="vx-col mt-4 mb-2">
          <div class="vx-row mb-3 mt-1">
            <div class="vx-col w-1/2">
              <vs-checkbox v-model="form.confirm">Confirm</vs-checkbox>
            </div>
            <div class="vx-col w-1/2">
              <vs-checkbox v-model="form.enable">Enable</vs-checkbox>
            </div>
          </div>
        </div>
      </vs-prompt>
    </vx-card>

    <!-- Popup Menu -->
    <vs-popup
      title="Menu"
      :active.sync="menu.show"
    >
    <div class="vx-col mb-2">
      <div class="vx-row mb-3">
        <div class="vx-col w-full">
          <vs-input class="w-full" v-model="menu.filter" @keyup.enter="filterMenu"/>
        </div>
      </div>
    </div>
    <ag-grid-vue
      :gridOptions="menu.gridOptions"
      class="ag-theme-material w-100 my-4 ag-grid-table"
      :columnDefs="menu.columnDefs"
      :defaultColDef="defaultColDef"
      :rowData="menu.rowData"
      rowSelection="single"
      @rowDoubleClicked="setMenu"
      colResizeDefault="shift"
      :animateRows="false"
      :floatingFilter="false"
    ></ag-grid-vue>
    </vs-popup>

    <!-- Popup User Group -->
    <vs-popup
      title="User Group"
      :active.sync="userGroup.show"
    >
    <div class="vx-col mb-2">
      <div class="vx-row mb-3">
        <div class="vx-col w-full">
          <vs-input class="w-full" v-model="userGroup.filter" @keyup.enter="filterUserGroup"/>
        </div>
      </div>
    </div>
    <ag-grid-vue
      :gridOptions="userGroup.gridOptions"
      class="ag-theme-material w-100 my-4 ag-grid-table"
      :columnDefs="userGroup.columnDefs"
      :defaultColDef="defaultColDef"
      :rowData="userGroup.rowData"
      rowSelection="single"
      @rowDoubleClicked="setUserGroup"
      colResizeDefault="shift"
      :animateRows="false"
      :floatingFilter="false"
    ></ag-grid-vue>
    </vs-popup>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";
import vSelect from "vue-select";

export default {
  components: {
    vSelect,
    AgGridVue
  },
  data() {
    return {
      gridOptions: {},
      gridApi: null,
      columnDefs: null,
      defaultColDef: {
        sortable: true,
        editable: false,
        resizable: true,
        suppressMenu: true
      },
      // Data Holder
      groupAccesses: [],
      menus: [],
      user_groups: [],
      enables: [{ name: "Yes", id: "true" }, { name: "No", id: "false" }],
      add: {},
      viewdit: {},
      form: {
        user_group: null,
        menu: null,
        create: true,
        read: true,
        update: true,
        delete: true,
        print: true,
        export: true,
        confirm: true,
        enable: true
      },

      selectedId: null,
      isLoading: false,
      totalPage: 1,
      currentPage: 1,
      dataFrom: 0,
      dataTo: 0,
      dataTotal: 0,
      filter: {
        user_group: '',
        menu: '',
      },

      // form
      showFilter: false,
      showAdd: false,
      showViewEdit: false,

      menu: {
        rowData: [],
        gridOptions: {},
        columnDefs: {},
        gridApi: null,
        show: false,
        filter: ''
      },
      userGroup: {
        rowData: [],
        gridOptions: {},
        columnDefs: {},
        gridApi: null,
        show: false,
        filter: ''
      }
    };
  },
  watch: {
    isLoading: function() {
      if (this.isLoading) {
        this.$vs.loading();
      } else {
        this.$vs.loading.close();
      }
    },
    currentPage: function() {
      this.fetchData();
    }
  },
  methods: {
    onSelectionChanged() {
      var selectedRows = this.gridApi.getSelectedRows();
      var selectedRowsString = "";
      selectedRows.forEach(function(selectedRow, index) {
        if (index !== 0) {
          selectedRowsString += ", ";
        }
        selectedRowsString += selectedRow.id;
      });
      this.selectedId = selectedRowsString;
    },
    removeItem() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Confirm",
        text: "Are you sure want to delete this user?",
        accept: this.acceptAlert
      });
    },
    acceptAlert() {
      this.isLoading = true;
      this.$http
        .delete("rolemanagement/groupaccess/" + this.selectedId + "/destroy")
        .then(() => {
          this.$vs.notify({
            color: "success",
            title: "User deleted",
            iconPack: "feather",
            icon: "icon-check",
            text: "The selected user was successfully deleted"
          });
        })
        .catch(error => {
          const message = error.response.data.message
            ? error.response.data.message
            : "Something went wrong";
          this.$vs.notify({
            title: "Error",
            text: message,
            color: "danger"
          });
        })
        .then(() => {
          this.fetchData();
        });
    },
    refreshData() {
      this.fetchData();
    },
    fetchData() {
      this.isLoading = true;
      this.$http
        .post(
          "rolemanagement/groupaccess?page=" + this.currentPage,
          this.filter
        )
        .then(resp => {
          this.groupAccesses = resp.data.data.map(item => {
            return {
              id: item.id,
              enable: item.enable == 1 ? "Yes" : "No",
              confirm: item.confirm == 1 ? "Yes" : "No",
              create: item.create == 1 ? "Yes" : "No",
              delete: item.delete == 1 ? "Yes" : "No",
              export: item.export == 1 ? "Yes" : "No",
              print: item.print == 1 ? "Yes" : "No",
              read: item.read == 1 ? "Yes" : "No",
              update: item.update == 1 ? "Yes" : "No",
              user_group: item.user_group,
              menu: item.menu
            };
          });

          this.totalPage = resp.data.last_page;
          this.dataTotal = resp.data.total;
          this.dataFrom = resp.data.from;
          this.dataTo = resp.data.to;
          this.currentPage = resp.data.current_page;
        })
        .catch(resp => {
          this.$vs.dialog({
            type: "confirm",
            color: "danger",
            title: "Something went wrong",
            text: "Try again?",
            accept: () => {
              this.fetchData();
            },
            acceptText: "Yes",
            cancelText: "No"
          });
        })
        .then(() => (this.isLoading = false));
    },
    addForm() {
      this.form.create = 1;
      this.form.read = 1;
      this.form.update = 1;
      this.form.delete = 1;
      this.form.print = 1;
      this.form.export = 1;
      this.form.confirm = 1;
      this.form.enable = 1;
      this.form.menu = null;
      this.form.user_group = null;
      this.showAdd = true;
    },
    addSubmit() {
      this.showAdd = false;
      this.$http
        .post("rolemanagement/groupaccess/store", this.form)
        .then(resp => {
          this.$vs.notify({
            color: "success",
            title: "Store",
            iconPack: "feather",
            icon: "icon-check",
            text: "Store Successfully"
          });
          this.currentPage = 1;
          this.fetchData();
        })
        .catch(err => {
          const message = err.response.data.message ? err.response.data.message : 'Something went wrong.'
          this.$vs.notify({
            color: "danger",
            title: "Error",
            iconPack: "feather",
            icon: "icon-check",
            text: message
          })
        })
    },
    viewEditForm() {
      this.$http
        .get("rolemanagement/groupaccess/" + this.selectedId)
        .then(resp => {
          this.form.create = resp.data.create;
          this.form.read = resp.data.read;
          this.form.update = resp.data.update;
          this.form.delete = resp.data.delete;
          this.form.print = resp.data.print;
          this.form.export = resp.data.export;
          this.form.confirm = resp.data.confirm;
          this.form.enable = resp.data.enable;
          this.form.menu = resp.data.menu;
          this.form.user_group = resp.data.code;
          this.showViewEdit = true;
        })
        .catch(err => console.log(err));
    },
    viewEditSubmit() {
      this.showViewEdit = false;
      this.$http
        .put(
          "rolemanagement/groupaccess/" + this.selectedId + "/update",
          this.form
        )
        .then(resp => {
          this.$vs.notify({
            color: "success",
            title: "Store",
            iconPack: "feather",
            icon: "icon-check",
            text: "Store Successfully"
          });
          this.currentPage = 1;
          this.fetchData();
        })
        .catch(err =>
          this.$vs.notify({
            color: "danger",
            title: "Error",
            iconPack: "feather",
            icon: "icon-check",
            text: err
          })
        );
    },
    getDataDropdown() {
      Promise.all([
        this.$http.post("rolemanagement/usergroup/dropdown"),
        this.$http.post("rolemanagement/menu/dropdown")
      ])
        .then(
          this.$http.spread((user_groups, menus) => {
            this.user_groups = user_groups.data;
            this.menus = menus.data;
          })
        )
        .catch(err => console.log(err));
    },
    filterForm() {
      this.filter.create = 1;
      this.filter.read = 1;
      this.filter.update = 1;
      this.filter.delete = 1;
      this.filter.print = 1;
      this.filter.export = 1;
      this.filter.confirm = 1;
      this.filter.enable = 1;
      this.filter.menu = null;
      this.filter.user_group = null;
      this.showFilter = true;
      this.getDataDropdown();
    },
    filterSubmit() {
      this.currentPage = 1;
      this.fetchData();
    },
    setMenu() {
      let selectedRows = this.menu.gridApi.getSelectedRows();
      let selectedRowsString = null;
      selectedRows.forEach(function(selectedRow, index) {
          if (index !== 0) {
              selectedRowsString += ", ";
          }
          selectedRowsString = selectedRow;
      });
      this.form.menu = selectedRowsString.menu;
      this.filter.menu = selectedRowsString.menu;
      this.menu.show = false
    },
    searchMenu() {
      if(this.menu.rowData.length < 1) {
        this.isLoading = true
        this.$http.post('rolemanagement/menu/filter/dropdown')
        .then(res => {
          this.menu.rowData = res.data
          this.menu.show = true
          this.menu.gridApi = this.menu.gridOptions.api
          this.menu.gridApi.sizeColumnsToFit()
          this.isLoading = false
        })
      }
      else {
        this.menu.show = true
      }
    },
    filterMenu() {
      this.isLoading = true
      this.$http.post('rolemanagement/menu/filter/dropdown', {menu: this.menu.filter})
      .then(res => {
        this.menu.rowData = res.data
        this.isLoading = false
      })
    },
    setUserGroup() {
      let selectedRows = this.userGroup.gridApi.getSelectedRows();
      let selectedRowsString = null;
      selectedRows.forEach(function(selectedRow, index) {
          if (index !== 0) {
              selectedRowsString += ", ";
          }
          selectedRowsString = selectedRow;
      });
      this.form.user_group = selectedRowsString.code;
      this.filter.user_group = selectedRowsString.code;
      this.userGroup.show = false
    },
    searchUserGroup() {
      if(this.userGroup.rowData.length < 1) {
        this.isLoading = true
        this.$http.post('rolemanagement/usergroup/filter/dropdown')
        .then(res => {
          this.userGroup.rowData = res.data
          this.userGroup.show = true
          this.userGroup.gridApi = this.userGroup.gridOptions.api
          this.userGroup.gridApi.sizeColumnsToFit()
          this.isLoading = false
        })
      }
      else {
        this.userGroup.show = true
      }
    },
    filterUserGroup() {
      this.isLoading = true
      this.$http.post('rolemanagement/usergroup/filter/dropdown', {name: this.userGroup.filter})
      .then(res => {
        this.userGroup.rowData = res.data
        this.isLoading = false
      })
    }
  },
  mounted() {
    this.fetchData();
    this.gridApi = this.gridOptions.api;
  },
  beforeMount() {
    this.columnDefs = [
      {
        headerName: "User Group",
        field: "user_group",
        width: 150,
      },
      {
        headerName: "Menu",
        field: "menu",
        width: 150,
      },
      {
        headerName: "Create",
        field: "create",
        width: 150,
      },
      {
        headerName: "Read",
        field: "read",
        width: 150,
      },
      {
        headerName: "Update",
        field: "update",
        width: 150,
      },
      {
        headerName: "Delete",
        field: "delete",
        width: 150,
      },
      {
        headerName: "Print",
        field: "print",
        width: 150,
      },
      {
        headerName: "Confirm",
        field: "confirm",
        width: 150,
      },
      {
        headerName: "Export",
        field: "export",
        width: 150,
      },
      {
        headerName: "Enable",
        field: "enable",
        width: 150,
      }
    ];

    this.menu.columnDefs = [
      {
        headerName: "Module",
        field: "module",
      },
      {
        headerName: "Menu",
        field: "menu",
      },
    ];

    this.userGroup.columnDefs = [
      {
        headerName: "Code",
        field: "code",
      },
      {
        headerName: "Name",
        field: "name",
      },
    ];
  }
};
</script>